import * as React from 'react';
import { RouterLinks } from 'src/routing/routerLinks';
import { useAsmRouter } from 'src/utils/hooks';
import { Dialog, DialogContent } from 'src/shadcn/components/ui/dialog';
import { Button } from 'src/shadcn/components/ui/button';
import { Calendar, GanttChartSquare, PlusCircle } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'src/shadcn/components/ui/dropdown-menu';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from 'src/shadcn/components/ui/sheet';
import { AppointmentWizardScreen } from '../WorkOrderCalendarView/AppointmentWizard/AppointmentWizardScreen';
import { Pill, PillType } from '../../Shared/Pill';
import { ScrollablePage } from '../../Shared/ScrollablePage';
import { CreateNewExpenseButton } from '../../Expenses/CreateNewExpenseButton';
import { cn } from 'src/shadcn/lib/utils';
import { CreateNewJobConfirmationModalBody } from './CreateNewJobConfirmationModalBody';
import { SidebarMenuButton } from 'src/shadcn/components/ui/sidebar';

export interface ICreateNewJobConfirmationModalProps {
  id?: string;
  isMinimized: boolean;
}

export const CreateNewJobConfirmationModal: React.FunctionComponent<
  ICreateNewJobConfirmationModalProps
> = props => {
  const router = useAsmRouter();
  const [
    createNewJobConfirmationModalOpen,
    setCreateNewJobConfirmationModalOpen,
  ] = React.useState(false);
  const [isAppointmentSheetOpen, setIsAppointmentSheetOpen] =
    React.useState(false);
  return (
    <>
      <Dialog
        open={createNewJobConfirmationModalOpen}
        onOpenChange={setCreateNewJobConfirmationModalOpen}
      >
        <Sheet
          open={isAppointmentSheetOpen}
          onOpenChange={setIsAppointmentSheetOpen}
        >
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <SidebarMenuButton variant={'outline'} sidebarId='main'>
                <PlusCircle />
                {!props.isMinimized && (
                  <span className='ml-2 text-xs'>Create</span>
                )}
              </SidebarMenuButton>
            </DropdownMenuTrigger>
            <DropdownMenuContent className='min-w-50'>
              <DropdownMenuItem
                onClick={() => {
                  setCreateNewJobConfirmationModalOpen(true);
                }}
              >
                <div className='flex items-center'>
                  <GanttChartSquare className='mr-2 h-4 w-4' />
                  <span>New work order</span>
                </div>
              </DropdownMenuItem>

              <SheetTrigger asChild>
                <DropdownMenuItem>
                  <div className='flex items-center'>
                    <Calendar className='mr-2 h-4 w-4' />
                    <span>New appointment</span>
                  </div>
                </DropdownMenuItem>
              </SheetTrigger>
              <DropdownMenuItem onClick={() => {}}>
                <CreateNewExpenseButton
                  onNewExpenseCreated={expense => {
                    router.pushFlat(RouterLinks.expenses, [expense.id]);
                  }}
                />
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>

          <SheetContent side={'bottom'} className='h-[80vh]'>
            <SheetHeader>
              <SheetTitle>
                <div className='flex items-center gap-3'>
                  <div>Appointment</div>
                </div>
              </SheetTitle>
            </SheetHeader>
            <div className='col-span-2 flex h-full overflow-y-hidden'>
              <ScrollablePage>
                <AppointmentWizardScreen
                  selectedAppointment={undefined}
                  onClose={() => {
                    setIsAppointmentSheetOpen(false);
                  }}
                />
              </ScrollablePage>
            </div>
          </SheetContent>
        </Sheet>
        <DialogContent>
          <CreateNewJobConfirmationModalBody />
        </DialogContent>
      </Dialog>
    </>
  );
};
